(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pickup-picker"] && !Shopify.designMode) return;
  try {
    class PickupPicker extends HTMLElement {
    connectedCallback() {
      this.lead = parseInt(this.dataset.lead || '0', 10);
      this.tz = this.dataset.tz || undefined;
      this.dates = [...this.querySelectorAll('input[name="properties[_pickup_date]"]')];
      this.times = [...this.querySelectorAll('input[name="properties[_pickup_time]"]')];
      this.dateOut = this.querySelector('input[data-pickup-visible="date"]');
      this.timeOut = this.querySelector('input[data-pickup-visible="time"]');
      this.none = this.querySelector('[data-pickup-none]');
      this.touched = false;
      this.dates.forEach((d) => d.addEventListener('change', () => { this.touched = true; this.sync(); }));
      this.times.forEach((t) => t.addEventListener('change', () => { this.touched = true; this.mirror(); }));
      this.sync();
      this.preselect();
    }

    /* TCE patch (1 Oct 2026), Rec 2: remember the chosen day.
       1. ?pickup=YYYY-MM-DD (Pick a day cards, Ready today, the cart's "see what else") picks that
          day if this dish offers it.
       2. Otherwise, if the cart has items, the cart's most common day + window (by quantity) is
          picked when this dish offers them.
       Only radios that exist and are enabled can be picked, so a day the dish can't do is never
       preselected. A choice the customer has already made is never overridden. */
    preselect() {
      if (!this.dates.length) return;
      let wanted = '';
      try {
        wanted = new URLSearchParams(window.location.search).get('pickup') || '';
      } catch (e) { wanted = ''; }
      if (/^\d{4}-\d{2}-\d{2}$/.test(wanted)) {
        const d = this.dates.find((x) => x.dataset.iso === wanted && !x.disabled);
        if (d) {
          d.checked = true;
          this.sync();
          return;
        }
      }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : null))
        .then((cart) => {
          if (!cart || !cart.items || !cart.items.length || this.touched) return;
          const norm = (v) => String(v || '').replace(/\s+/g, ' ').trim();
          const tally = new Map();
          cart.items.forEach((item) => {
            const p = item.properties || {};
            const date = norm(p._pickup_date || p['Pickup date']);
            if (!date) return;
            const time = norm(p._pickup_time || p['Pickup time']);
            const k = `${date}\u0000${time}`;
            tally.set(k, (tally.get(k) || 0) + (item.quantity || 1));
          });
          let best = null;
          let bestQty = 0;
          tally.forEach((qty, k) => {
            if (qty > bestQty) { best = k; bestQty = qty; }
          });
          if (!best) return;
          const [date, time] = best.split('\u0000');
          const d = this.dates.find((x) => norm(x.value) === date && !x.disabled);
          if (!d) return;
          d.checked = true;
          this.sync();
          const t = this.times.find((x) => norm(x.value) === time && !x.disabled);
          if (t) {
            t.checked = true;
            this.mirror();
          }
        })
        .catch(() => {});
    }

    /* Copies the chosen radio's translated value (data-prop) into the visible property input.
       Nothing chosen: the input is disabled, so no half pair reaches the cart. */
    mirror() {
      [
        [this.dates, this.dateOut],
        [this.times, this.timeOut],
      ].forEach(([set, out]) => {
        if (!out) return;
        const chosen = set.find((i) => i.checked && !i.disabled);
        out.value = chosen ? chosen.dataset.prop || chosen.value : '';
        out.disabled = !chosen;
      });
    }

    /* Today's date and minutes after midnight in the STORE's time zone, not the phone's. */
    clock() {
      const now = new Date();
      try {
        const parts = {};
        new Intl.DateTimeFormat('en-CA', {
          timeZone: this.tz,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        })
          .formatToParts(now)
          .forEach((p) => (parts[p.type] = p.value));
        return {
          iso: `${parts.year}-${parts.month}-${parts.day}`,
          mins: (parseInt(parts.hour, 10) % 24) * 60 + parseInt(parts.minute, 10),
        };
      } catch (e) {
        const pad = (n) => String(n).padStart(2, '0');
        return {
          iso: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`,
          mins: now.getHours() * 60 + now.getMinutes(),
        };
      }
    }

    /* The chip for the store's today reads "Today" / "Hoy"; every other chip keeps its
       server-rendered label ("Wed 30 Sep" / "mié 30 sep", the same words as the cart). This
       only matters when the page came from a cache made on an earlier day. No Intl date
       formatting here: Intl's Spanish ("mié, 30 sept") would not match the cart or the email. */
    relabel(todayIso) {
      this.dates.forEach((d) => {
        const label = this.querySelector(`label[for="${d.id}"]`);
        if (!label || !d.dataset.iso) return;
        if (d.dataset.iso === todayIso) {
          label.textContent = this.dataset.todayLabel || label.textContent;
        } else if (d.dataset.label) {
          label.textContent = d.dataset.label;
        }
      });
    }

    sync() {
      if (!this.dates.length) return;
      const { iso: todayIso, mins } = this.clock();
      const cutoff = mins + (Number.isFinite(this.lead) ? this.lead : 0);
      this.relabel(todayIso);

      /* Today stays only while at least one window can still be made after the notice period.
         A date before today (page served from an old cache) is never offered. */
      const windowLeftToday = this.times.some((t) => parseInt(t.dataset.mins, 10) >= cutoff);
      this.dates.forEach((d) => {
        const off = d.dataset.iso < todayIso || (d.dataset.iso === todayIso && !windowLeftToday);
        d.disabled = off;
        if (off) d.checked = false;
        const label = this.querySelector(`label[for="${d.id}"]`);
        if (label) label.hidden = off;
      });

      let chosen = this.dates.find((d) => d.checked && !d.disabled);
      if (!chosen) {
        chosen = this.dates.find((d) => !d.disabled) || null;
        if (chosen) chosen.checked = true;
      }
      if (this.none) this.none.hidden = Boolean(chosen);

      const isToday = Boolean(chosen) && chosen.dataset.iso === todayIso;
      let firstOpen = null;
      this.times.forEach((t) => {
        const past = !chosen || (isToday && parseInt(t.dataset.mins, 10) < cutoff);
        t.disabled = past;
        if (past) t.checked = false;
        const label = this.querySelector(`label[for="${t.id}"]`);
        if (label) label.hidden = past;
        if (!past && firstOpen === null) firstOpen = t;
      });

      const checked = this.times.find((t) => t.checked);
      if ((!checked || checked.disabled) && firstOpen) firstOpen.checked = true;
      this.mirror();
    }
  }

  if (!customElements.get('pickup-picker')) {
    customElements.define('pickup-picker', PickupPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticky-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tce-sticky-cart')) {
    class TceStickyCart extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
        this.bar = this.querySelector('.tce-sticky');
        // Horizon sections can set container-type/transform, which traps position:fixed
        // inside the section. Move the bar to <body> so it always pins to the screen.
        // Left in place inside the theme editor so the block stays clickable there.
        if (this.bar && !window.Shopify?.designMode) {
          document.querySelectorAll('body > #TceStickyCart').forEach((old) => old.remove());
          document.body.appendChild(this.bar);
        }
        document.addEventListener('shopify:cart:lines-update', this.onUpdate);
        window.addEventListener('pageshow', (e) => { if (e.persisted) this.refresh(); });
        this.watchHeight();
        this.watchProductPage();
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:cart:lines-update', this.onUpdate);
        if (this.io) this.io.disconnect();
        if (this.mo) this.mo.disconnect();
        if (this.ro) this.ro.disconnect();
      }
      /* The bar grows to two lines with a long label (Spanish runs longer). Pad the page by
         its real height so the footer is never hidden under it. */
      watchHeight() {
        if (!this.bar || !('ResizeObserver' in window)) return;
        this.ro = new ResizeObserver(() => {
          const h = this.bar.offsetHeight;
          if (h > 0) document.documentElement.style.setProperty('--tce-sticky-h', `${Math.ceil(h)}px`);
        });
        this.ro.observe(this.bar);
      }
      /* Product page: never cover the pickup picker or Add to cart. Tuck the bar while either
         is on screen, and while Horizon's own sticky Add to cart bar is showing. */
      watchProductPage() {
        if (!this.bar) return;
        this.onScreen = new Set();
        const targets = document.querySelectorAll('pickup-picker, .buy-buttons-block');
        if (targets.length && 'IntersectionObserver' in window) {
          // Start tucked until the observer's first report, so the bar can't flash over Add to cart.
          this.waitingForObserver = true;
          this.io = new IntersectionObserver((entries) => {
            this.waitingForObserver = false;
            entries.forEach((e) => (e.isIntersecting ? this.onScreen.add(e.target) : this.onScreen.delete(e.target)));
            this.applyTuck();
          });
          targets.forEach((t) => this.io.observe(t));
        }
        this.horizonBar = document.querySelector('.sticky-add-to-cart__bar');
        if (this.horizonBar && 'MutationObserver' in window) {
          this.mo = new MutationObserver(() => this.applyTuck());
          this.mo.observe(this.horizonBar, { attributes: true, attributeFilter: ['data-stuck'] });
        }
        this.applyTuck();
      }
      applyTuck() {
        if (!this.bar) return;
        const horizonShowing = Boolean(this.horizonBar) && this.horizonBar.getAttribute('data-stuck') === 'true';
        const tuck = Boolean(this.waitingForObserver) || (this.onScreen && this.onScreen.size > 0) || horizonShowing;
        this.bar.toggleAttribute('data-tucked', tuck);
        if (tuck) this.bar.setAttribute('tabindex', '-1');
        else this.bar.removeAttribute('tabindex');
      }
      onUpdate(event) {
        const done = event && event.promise ? event.promise.catch(() => null) : Promise.resolve();
        done.then(() => this.refresh());
      }
      async refresh() {
        try {
          const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
          if (!res.ok) return;
          const cart = await res.json();
          const bar = this.bar;
          if (!bar) return;
          const n = cart.item_count || 0;
          bar.hidden = n === 0;
          const countEl = bar.querySelector('[data-count]');
          const labelEl = bar.querySelector('[data-label]');
          const totalEl = bar.querySelector('[data-total]');
          if (countEl) countEl.textContent = String(n);
          if (labelEl) labelEl.textContent = (n === 1 ? this.dataset.labelOne : this.dataset.labelMany) || '';
          if (totalEl) {
            /* "es" alone formats dollars as "20,00 US$"; the US region gives "$20.00", the same
               as the server-rendered total and the rest of the store. */
            let lang = document.documentElement.lang || 'en';
            if (!lang.includes('-')) lang = `${lang}-US`;
            let fmt;
            try {
              fmt = new Intl.NumberFormat(lang, { style: 'currency', currency: cart.currency || 'USD' });
            } catch (e) {
              fmt = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' });
            }
            totalEl.textContent = fmt.format((cart.total_price || 0) / 100);
          }
        } catch (e) { /* leave the server-rendered bar as it is */ }
      }
    }
    customElements.define('tce-sticky-cart', TceStickyCart);
  }
  } catch(e) { console.error(e); }
})();

})();
